import {Action, Team, ActionType , Player,Hero, GameType} from '../types'

import {GetExclucsionList} from './playerUtils'

import {getHeroData} from '../heroes/useHeroes'

export function DraftHeroes (heroList:any, heroCount:number, unique:boolean) : Hero[][]{
    let draftResult = [];
    let drawArray = GenerateHeroesDrawArray(heroList)

    for(let i = 0; i < 4; i++ ){
        let playerHeroes = []
        if(!unique) drawArray = GenerateHeroesDrawArray(heroList)

        for(let j = 0; j < heroCount; j++){

            const rng = getRandomInt(drawArray.length);
            const pick = drawArray[rng];
            drawArray.splice(rng, 1);
            
            const pickedHero : Hero = heroList[Object.keys(heroList)[pick]];

            pickedHero.Banned = false;
            pickedHero.Picked = false;
            playerHeroes.push(Object.assign({}, pickedHero));
        }
        draftResult.push(playerHeroes);
    }
    return draftResult;
}

export function GetRandomHero (heroList:any){
    let drawArray = GenerateHeroesDrawArray(heroList)
    const rng = getRandomInt(drawArray.length);
    const pick = drawArray[rng];

    const pickedHero = heroList[Object.keys(heroList)[pick]];
    return pickedHero;
}

export function GetRandomHeroForPlayer(type : GameType,  player : Player) : Hero {
    const heroList = FilterHeroList(getHeroData(type), GetExclucsionList(player));
    return GetRandomHero(heroList);
}


export function FilterHeroList(heroList : any, excludeList:string[]){
    const heroListCopy = Object.assign({}, heroList);
    for(var key in heroListCopy){
        var hero = heroListCopy[key];
        if(excludeList.includes(hero['Name'])){
            delete heroListCopy[key];
        }
    }
    return heroListCopy;
}

export function GetHeroesBasedOnTier(heroList:any, includedTiers:number[]){
    const heroListCopy = Object.assign({}, heroList);
    for(var key in heroListCopy){
        var hero = heroListCopy[key];
        if(!includedTiers.includes(hero['Tier'])){
            delete heroListCopy[key];
        }
    }
    return heroListCopy;
}



export function GetPlayerDraft(count:number, heroList:any) : Hero[]{
    let result = [];
    let drawArray = GenerateHeroesDrawArray(heroList);

    for(let j = 0; j < count; j++){
        const rng = getRandomInt(drawArray.length);
        const pick = drawArray[rng];
        drawArray.splice(rng, 1);
        
        const pickedHero = heroList[Object.keys(heroList)[pick]];
        pickedHero['Action'] = null;
        result.push(pickedHero);
    }
    return result;
}   


function GenerateHeroesDrawArray(heroList:any){
    let drawArray = [];
    var count = Object.keys(heroList).length;
    for(var i = 0 ; i < count; i++){
        drawArray.push(i);
    }
    return drawArray;
}


export function GetRandomPickOrder(){
    const pickOrder = [];
    const coinToss = getRandomInt(2);

    let team1 = Team.Blue;
    let team2 = Team.Red;

    if(coinToss === 0){
        team1 = Team.Red;
        team2 = Team.Blue;
    }
    
    pickOrder.push(getPickObject(team1, ActionType.Pick));

    pickOrder.push(getPickObject(team2, ActionType.Pick));
    pickOrder.push(getPickObject(team2, ActionType.Pick));

    pickOrder.push(getPickObject(team1, ActionType.Pick));

    pickOrder.push(getPickObject(team1, ActionType.Shop));
    pickOrder.push(getPickObject(team2, ActionType.Shop));

    pickOrder.push(getPickObject(team2, ActionType.Ban));
    pickOrder.push(getPickObject(team1, ActionType.Ban));

    return pickOrder;
}

export function GetDuelPickOrder(){
    const pickOrder = [];
    const coinToss = getRandomInt(2);

    let team1 = Team.Blue;
    let team2 = Team.Red;

    if(coinToss === 0){
        team1 = Team.Red;
        team2 = Team.Blue;
    }
    
    pickOrder.push(getPickObject(team2, ActionType.Pick));

    pickOrder.push(getPickObject(team1, ActionType.Pick));

    pickOrder.push(getPickObject(team1, ActionType.Shop));
    pickOrder.push(getPickObject(team2, ActionType.Shop));

    pickOrder.push(getPickObject(team2, ActionType.Ban));
    pickOrder.push(getPickObject(team1, ActionType.Ban));

    return pickOrder;
}

export function GetFFAPickOrder() {
    const pickOrder = [];

    let team1 = Team.Blue;
    let team2 = Team.Red;
    
    pickOrder.push(getPickObject(team1, ActionType.Pick, 4));
    pickOrder.push(getPickObject(team2, ActionType.Pick, 3));
    pickOrder.push(getPickObject(team2, ActionType.Pick, 2));
    pickOrder.push(getPickObject(team1, ActionType.Pick, 1));


    pickOrder.push(getPickObject(team2, ActionType.Shop, 1));
    pickOrder.push(getPickObject(team1, ActionType.Shop, 2));
    pickOrder.push(getPickObject(team2, ActionType.Shop, 3));
    pickOrder.push(getPickObject(team1, ActionType.Shop, 4));

    return pickOrder;
}


function getPickObject(team:Team, action: ActionType, playerNumber? : number){
    const pickAction = {} as Action
    pickAction.Action = action;
    pickAction.Team = team;
    pickAction.PlayerNumber = playerNumber
    return pickAction;
}


export function getRandomInt(max:number) {
    return Math.floor(Math.random() * max);
}



